import { render, staticRenderFns } from "./CircleFlip.vue?vue&type=template&id=1fb705be&scoped=true&"
import script from "./CircleFlip.vue?vue&type=script&lang=js&"
export * from "./CircleFlip.vue?vue&type=script&lang=js&"
import style0 from "./CircleFlip.vue?vue&type=style&index=0&id=1fb705be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb705be",
  null
  
)

export default component.exports